export const secondsToMinutes = (seconds: number): number => Math.round(seconds / 60);

export default {};
